import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { tokenValidate } from 'src/app/onboarding/routes';
import { Loading } from 'src/components/common/loading/Loading';
import { NONCE_KEY } from 'src/hooks/useHandleProviderSubmit';
import {
  readFromLocalStorage,
  removeFromLocalStorage,
} from 'src/hooks/useLocalStorage';
import { useRouteParams } from 'src/hooks/useRouteParams';
import { Config } from 'src/lib/config/config';
import { goLogout } from 'src/lib/goLogout';
const { loginErrorUrl } = Config;

export const TokenValidatePage = () => {
  const { state: nonceFromQuery, postLogin } = useRouteParams(tokenValidate);
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>(
    'loading',
  );

  useEffect(() => {
    if (status === 'success') return;

    if (!nonceFromQuery) {
      setStatus('error');
      return;
    }

    // Get the nonce from localStorage and confirm it matches the one passed back
    const nonceFromStorage = readFromLocalStorage(NONCE_KEY);
    if (!!nonceFromStorage && nonceFromQuery === nonceFromStorage) {
      setStatus('success');
    } else {
      setStatus('error');
    }
  }, [nonceFromQuery, status]);

  if (status === 'loading') {
    return <Loading />;
  }

  // Remove the nonce so it can't be reused
  removeFromLocalStorage(NONCE_KEY);

  if (status === 'success') {
    const postLoginUrl = postLogin ?? '/';
    return <Redirect to={postLoginUrl} />;
  } else {
    goLogout({ callbackUrl: loginErrorUrl });
    return <Loading />;
  }
};
